<template>
    <Head title="Lounge Wizard" />
    <div class="px-4 md:px-8">
        <LoungeWizard />
    </div>
</template>

<script setup>
import LoungeWizard from '@/components/tools/lounges/lounge-wizard/index.vue';
import { Head } from '@inertiajs/vue3';
</script>
